'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACTION__ADD_ITEM_TO_CART = exports.ACTION__ADD_ITEM_TO_CART = 'pushCart/ACTION__ADD_ITEM_TO_CART';
var ACTION__REMOVE_ITEM = exports.ACTION__REMOVE_ITEM = 'pushCart/ACTION__REMOVE_ITEM';
var ACTION__REMOVE_ALL_ITEMS = exports.ACTION__REMOVE_ALL_ITEMS = 'pushCart/ACTION__REMOVE_ALL_ITEMS';
var ACTION__UPDATE_QUANTITY_OF_ITEM = exports.ACTION__UPDATE_QUANTITY_OF_ITEM = 'pushCart/ACTION__UPDATE_QUANTITY_OF_ITEM';
var ACTION__UPDATE_QUANTITY_OF_MULTIPLE_ITEMS = exports.ACTION__UPDATE_QUANTITY_OF_MULTIPLE_ITEMS = 'pushCart/ACTION__UPDATE_QUANTITY_OF_MULTIPLE_ITEMS';

var MUTATION__UPDATE_LINE_ITEMS = exports.MUTATION__UPDATE_LINE_ITEMS = 'pushCart/MUTATION__UPDATE_LINE_ITEMS';

var GET_INITIAL_DATA = exports.GET_INITIAL_DATA = 'pushCart/GET_INITIAL_DATA';
var GET_ITEM_COUNT = exports.GET_ITEM_COUNT = 'pushCart/GET_ITEM_COUNT';
var GET_LINE_ITEMS = exports.GET_LINE_ITEMS = 'pushCart/GET_LINE_ITEMS';
var GET_LOADING = exports.GET_LOADING = 'pushCart/GET_LOADING';
var GET_SUBTOTAL = exports.GET_SUBTOTAL = 'pushCart/GET_SUBTOTAL';

var GET_GIFT_PRODUCTS = exports.GET_GIFT_PRODUCTS = 'pushCart/GET_GIFT_PRODUCTS';
var GET_GIFT_THRESHOLD = exports.GET_GIFT_THRESHOLD = 'pushCart/GET_GIFT_THRESHOLD';
var GET_GIFT_MAX_GIFTS = exports.GET_GIFT_MAX_GIFTS = 'pushCart/GET_GIFT_MAX_GIFTS';
var GET_GIFT_DISCOUNT_RATE = exports.GET_GIFT_DISCOUNT_RATE = 'pushCart/GET_GIFT_DISCOUNT_RATE';
var GET_GIFT_INITIALLY_OPEN = exports.GET_GIFT_INITIALLY_OPEN = 'pushCart/GET_GIFT_INITIALLY_OPEN';